if (!window._babelPolyfill) {
  require('babel-polyfill');
}
import React from 'react';
import {Router, Route, browserHistory} from 'react-router';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import jQuery from 'jquery';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import muiEditorComponents from 'crazyEditor/theme/muiEditorComponents';
import PricingWidget from './PricingWidget';
import muiEditorTheme from 'crazyEditor/theme/muiEditorTheme';

require('gsap/ScrollToPlugin');

const Widget = props => (
  <div>
    <MuiThemeProvider muiTheme={_.merge(getMuiTheme(muiEditorTheme), muiEditorComponents)}>
      <PricingWidget
        integrated
        plans={window.plans.sort((a, b) => b.price - a.price)}
        premiumPlan={window.premiumPlan}
        paidFeaturesData={window.paidFeaturesData}
        supportLiveEbayListings={window.supportLiveEbayListings}
        type={window.pricingWidgetVersion}
        pricingGeneration={window.pricingGeneration}
        location={props.location}
        subTitle={`Unlimited for ${window.trialDuration} Days, No Credit Card Required`}
        openChat={text => {
          if (window.Intercom) {
            window.Intercom('showNewMessage', text);
          } else if (window.Tawk_API) {
            window.Tawk_API.maximize();
          }
        }}
      />
    </MuiThemeProvider>
  </div>
);

jQuery('.cl-pricing-widget').replaceWith('<div id="Pricing" style="min-height: inherit;"></div>');
const dest = document.getElementById('Pricing');

if (dest !== null) {
  ReactDOM.render(
    <Router history={browserHistory}>
      <Route path="*" component={Widget} />
    </Router>,
    dest
  );
}
